import React from 'react';

import { defaultActionCellButtonCDSProps } from '@sharedCR/coreDesignSystem/Table/TableCDS/cellContent';

import { normalizeViewPhoneNumber } from 'utils/data';

import { CellIds } from './FeeProviderLocationTable.testIds';
import RowActionButton from './RowActionButton';

export const tableConfig = {
  [CellIds.STREET_ADDRESS]: {
    label: 'Street',
    sort: true,
  },
  [CellIds.SUITE]: {
    label: 'Suite',
  },
  [CellIds.CITY]: {
    label: 'City',
  },
  [CellIds.STATE]: {
    label: 'State',
  },
  [CellIds.ZIP_CODE]: {
    label: 'Zip Code',
  },
  [CellIds.CONTACT_PERSON]: {
    label: 'Contact Person',
  },
  [CellIds.CONTACT_PHONE]: {
    label: 'Contact Phone',
    content: ({ contactPhone }) => normalizeViewPhoneNumber(contactPhone),
  },
  [CellIds.CONTACT_EMAIL]: {
    label: 'Contact Email',
  },
  [CellIds.PHONE]: {
    label: 'Phone',
    content: ({ phone }) => normalizeViewPhoneNumber(phone),
  },
  [CellIds.EMAIL]: {
    label: 'Email',
  },
  [CellIds.LICENSE_NUMBER]: {
    label: 'License Number',
  },
  [CellIds.ACCOUNT_NAME]: {
    label: 'Account Name',
  },
  [CellIds.ROUTING_NUMBER]: {
    label: 'Routing Number',
  },
  [CellIds.ACCOUNT_NUMBER]: {
    label: 'Account Number',
  },
  action: {
    ...defaultActionCellButtonCDSProps,
    content: rowData => <RowActionButton rowData={rowData} />,
  },
};
